<template>
  
  <HomeComponent></HomeComponent>
  
</template>

<script>

import HomeComponent from './components/HomeComponent.vue';

export default {
  name: 'App',
  components: {
    HomeComponent
},
data() {
  return {};
}
}

</script>

<style lang = scss>


</style>
